export interface Widget {
    classNames?: string;
    id:          string;
    type:        Type;
}

export enum Type {
    Associations = "associations",
    Attachments = "attachments",
    Baskets = "baskets",
    Custom = "custom",
    Edito = "edito",
    Footer = "footer",
    Header = "header",
    Image = "image",
    Menu = "menu",
    Mosaic = "mosaic",
    News = "news",
    Report = "report",
    Search = "search",
    SectionTitle = "sectionTitle",
    Sheet = "sheet",
    Spacer = "spacer",
    Tabs = "tabs",
    Thematic = "thematic",
    Video = "video",
}
